export default "__VITE_ASSET__yTCT1g$8__"